const { createStore, applyMiddleware } = require('redux');
const { default: thunk } = require('redux-thunk');
const { default: reducers } = require('./reducers');

export const store = createStore(reducers, applyMiddleware(thunk));
